<template>
  <div class="radish-right" v-if="isShow">
    <div class="radish-head">
      <div class="radish-title">重复处理({{ resData.length }})</div>
      <div class="radish-btns"><div class="radish-btn" @click="close">关闭</div></div>
    </div>
    <div v-loading="loading" style="padding-top:50px">
      <div class="radish-box" v-if="resData.length > 0">
        <div>
          <el-button size="mini" @click="mergeMult('n')">以本次数据为主</el-button>
          <el-button size="mini" @click="mergeMult('o')">以旧数据为主</el-button>
          <el-button size="mini" @click="removeMult">放弃本次上传</el-button>
        </div>
        <div class="radish-box-content">
          <el-table
            border
            :data="resData"
            :resizable="false"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="35"></el-table-column>
            <el-table-column label="本次上传" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.newData['姓名'] }}</span>
              </template>
            </el-table-column>
            <el-table-column label="系统重复" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.oldData['姓名'] }}</span>
                <div v-if="scope.row.newData['姓名'] != scope.row.oldData['姓名']" style="color:#f00">姓名不一致</div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="compareDetail(scope.row)">对比详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DupDetail from './dup-detail'
export default {
  components: { DupDetail },
  data: function() {
    return {
      isShow: false,
      loading: false,
      multipleSelection: [],
      resData: [],
    }
  },
  methods: {
    open: function(params) {
      const { resData } = params
      this.resData = resData
      this.multipleSelection = []
      this.isShow = true
    },
    close: function() {
      this.isShow = false
    },
    handleSelectionChange: function(val) {
      this.multipleSelection = val
    },
    // mergeOne: async function(index, row, main) {
    //   this.loading = true
    //   let n = row.newData
    //   let data = [
    //     {
    //       o: { _id: row.oldData._id },
    //       n: n,
    //     },
    //   ]
    //   const res = await app.service('radish').merge({
    //     data: data,
    //     main: main,
    //     from: 'list',
    //   })
    //   if (res.status == 'success') {
    //     this.removeRow(index)
    //   } else {
    //     this.$message.error(res.msg)
    //   }
    //   this.loading = false
    // },
    // removeRow: function(index) {
    //   this.resData.splice(index, 1)
    //   this.$message.success({ duration: 500, message: '操作成功' })
    //   if (this.resData.length == 0) {
    //     this.close()
    //   }
    // },
    removeMult: function() {
      let rows = this.multipleSelection
      if (rows.length == 0) {
        this.$alert('请先勾选', { showClose: false })
        return
      } else {
        let rowIndex = rows.map(row => {
          return row.oldData._id
        })
        this.resData = this.resData.filter(rd => {
          return !rowIndex.includes(rd.oldData._id)
        })
        this.$message.success({ duration: 500, message: '操作成功' })
        if (this.resData.length == 0) {
          this.close()
        }
      }
    },
    mergeMult: async function(main) {
      let rows = this.multipleSelection
      console.log(rows)
      if (rows.length == 0) {
        this.$alert('请先勾选', { showClose: false })
        return
      } else {
        this.loading = true
        let data = []
        for (const row of rows) {
          let n = row.newData
          data.push({
            o: { _id: row.oldData._id },
            n: n,
          })
        }
        const res = await app.service('radish').merge({
          data: data,
          main: main,
          from: 'list',
        })
        // console.log(res)
        if (res.status == 'success') {
          this.removeMult()
          this.loading = false
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    compareDetail: function(row) {
      app.root.$refs.DupDetail.show({ oldData: row.oldData, newData: row.newData, onConfirm: this.onConfirm })
    },
    onConfirm: function(oldId) {
      this.resData = this.resData.filter(rd => rd.oldData._id != oldId)
    },
  },
}
</script>
